// extracted by mini-css-extract-plugin
export var attachment = "_o4-a";
export var emailContainer = "_o4-4";
export var emailContentPaddedContainer = "_o4-b";
export var emailHeader = "_o4-6";
export var emailIframe = "_o4-3";
export var emailInfoIcon = "_o4-9";
export var emailShortenedSummary = "_o4-e";
export var infoDropdown = "_o4-0";
export var infoRowBoundedContent = "_o4-d";
export var internal = "_o4-5";
export var merchant = "_o4-8";
export var messageInputContainer = "_o4-h";
export var normal = "_o4-7";
export var replyCard = "_o4-f";
export var subtleButton = "_o4-1";
export var subtleButtonIconContainer = "_o4-2";
export var toggleViewRepliesButton = "_o4-c";
export var wrappingText = "_o4-g";